const listeners = new Map<string, ((data?: unknown) => void)[]>();

export function on(
  name: string,
  callback: (data?: unknown) => void,
): { unsubscribe: () => void } {
  if (!listeners.has(name)) {
    listeners.set(name, []);
  }
  listeners.get(name)?.push(callback);
  return {
    unsubscribe: () => {
      const listner = listeners.get(name);
      if (listner) {
        listner.splice(listner.indexOf(callback), 1);
      }
    },
  };
}

export function emit(name: string, data?: unknown) {
  listeners.get(name)?.forEach((callback) => callback(data));
}
